/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Parcel_NameInputs */

const vi_care_log_parcel_name = /** @type {(inputs: Care_Log_Parcel_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên lô`)
};

/**

* @param {Care_Log_Parcel_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_parcel_name = /** @type {((inputs?: Care_Log_Parcel_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Parcel_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_parcel_name(inputs)
});